@if ((loanService.application()?.loans && (loanService.application()?.loans?.length ?? 0) > 0) || loanService.application()?.studyLoan) {
  <h3 class="title">Lånekostnader</h3>

  <div class="group-holder">
    @if (loanService.application()?.studyLoan) {
      <h4 class="initial">Studielån</h4>
      <div class="subgroup-holder">
        <spb-kalp-item
          description="Totalt för hushållet (kr/mån)"
          format="1.0-0"
          text="Belopp"
          [value]="loanService.application()?.studyLoan"/>
      </div>
    }

    @for (loan of loanService.application()?.loans; track $index) {
      <h4
        [class]="$first && !loanService.application()?.studyLoan ? 'initial' : ''">
        Lån
        nummer {{ $index + 1 }}</h4>
      <div class="subgroup-holder">
        <spb-kalp-item
          format="1.0-0"
          text="Lånebelopp"
          [value]="loan.amount"/>
        <spb-kalp-item
          format="1.0-0"
          text="Typ"
          [textValue]="true"
          [value]="loan.type | loanType"/>
        <spb-kalp-item
          format="1.0-0"
          suffix="%"
          text="Räntesats"
          [value]="loan.interestPercent! * 100"/>
        <spb-kalp-item
          description="exklusive ränteavdrag"
          format="1.0-0"
          [value]="loan.interest"
          text="Ränta (kr/mån)"/>
        <spb-kalp-item
          format="1.0-0"
          text="Amortering (%/år)"
          [value]="loan.mortgagePercent! * 100"/>
        <spb-kalp-item
          format="1.0-0"
          text="Amortering (kr/mån)"
          [value]="loan.mortgage"/>
      </div>
    }
  </div>
}